import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

/// This is a container for holding a <label>, <input> and other decoration UI elements
class HalfWidthControlP extends React.PureComponent {
    render() {
        const { children } = this.props;
        return (
            <div className={styles['half-width']}>
                {children}
            </div>
        );
    }
}

HalfWidthControlP.propTypes = {
    children: PropTypes.node.isRequired,
};

export default HalfWidthControlP;
